import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-goods-refund",
  "use": "icon-goods-refund-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-goods-refund\"><defs><style type=\"text/css\"></style></defs><path d=\"M921.5488 200.0384A71.9872 71.9872 0 0 0 849.8176 128H174.1312C138.24 128 102.4 163.9936 102.4 200.0384v111.0272h819.1488V200.0384zM102.4 388.1984V835.072C102.4 885.248 131.0976 921.5488 174.1312 921.6h675.6864c28.6976 0 43.0848-7.168 57.3952-28.8256-107.6224-194.6368-236.7488-158.6432-236.7488-158.6432v115.3792l-179.3536-187.4176 179.3536-151.1936v115.072s222.208-28.8256 251.136 237.9264V388.1984H102.4z\" p-id=\"6682\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/goods-refund.svg
// module id = p0pA
// module chunks = 60